<div id="sticky-block" *ngIf="!hide" #stickBlock [ngClass]="{'guide':changeColorGuide, iphone: isIphoneDevice, 'changeBottom': showStickyChat}">
  <div class="sticky-back-top" *ngIf="!!buttons[0].showCommand()"
    (click)="clickAction(buttons[0])" [attr.id]="buttons[0].action">
    <span *ngIf="buttons[0].action">
      <i class="iconfont {{buttons[0].icon}}"></i>
    </span>
  </div>
  <div class="inner">
    <!-- <span class="arrow-box">
      <i class="tips-up-arrow iconfont iconjiantou_liebiaozhankai"></i>
      <i class="tips-down-arrow iconfont iconjiantou_liebiaoshouqi"></i>
    </span> -->
    <ng-container *ngFor="let item of buttons | slice:1">
      <div class="stick-block-button" *ngIf="!!item.showCommand()" (click)="clickAction(item)" [ngClass]="{'appIconColor': item.icon === 'iconxiazaiAPP'}"
        [attr.id]="item.action">
        <span *ngIf="!item.action">
          <i class="iconfont {{item.icon}}"></i>
        </span>
        <span *ngIf="item.action && !item.label">
          <i class="iconfont {{item.icon}}" [ngClass]="{'guide':changeColorGuide}"></i>
        </span>
        <span *ngIf="item.action && item.label">
          <div class="onlytext">访问<span class="text-word">{{ item.name }}</span></div>
        </span>
        <div class="hint" *ngIf="!item.label">
          {{item.name}}
        </div>
      </div>
    </ng-container>
    <span class="guide-tips" [ngClass]="{'topFixed':showBackToTopButton, 'guide':changeColorGuide}"
      (click)="closeGuide()">
    </span>
  </div>
</div>
